import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import { memo } from 'react';
import _ from '@lodash';
import GlobalStyles from '@mui/material/GlobalStyles';
import ABSNavHorizontalLayout1 from './horizontal/ABSNavHorizontalLayout1';
import ABSNavVerticalLayout1 from './vertical/ABSNavVerticalLayout1';
import ABSNavVerticalLayout2 from './vertical/ABSNavVerticalLayout2';
import ABSNavHorizontalCollapse from './horizontal/types/ABSNavHorizontalCollapse';
import ABSNavHorizontalGroup from './horizontal/types/ABSNavHorizontalGroup';
import ABSNavHorizontalItem from './horizontal/types/ABSNavHorizontalItem';
import ABSNavHorizontalLink from './horizontal/types/ABSNavHorizontalLink';
import ABSNavVerticalCollapse from './vertical/types/ABSNavVerticalCollapse';
import ABSNavVerticalGroup from './vertical/types/ABSNavVerticalGroup';
import ABSNavVerticalItem from './vertical/types/ABSNavVerticalItem';
import ABSNavVerticalLink from './vertical/types/ABSNavVerticalLink';
import { registerComponent } from './ABSNavItem';

const inputGlobalStyles = (
  <GlobalStyles
    styles={(theme) => ({
      '.popper-navigation-list': {
        '& .abs-list-item': {
          padding: '8px 12px 8px 12px',
          height: 40,
          minHeight: 40,
          '& .abs-list-item-text': {
            padding: '0 0 0 8px',
          },
        },
        '&.dense': {
          '& .abs-list-item': {
            minHeight: 32,
            height: 32,
            '& .abs-list-item-text': {
              padding: '0 0 0 8px',
            },
          },
        },
      },
    })}
  />
);

/*
Register ABS Navigation Components
 */
registerComponent('vertical-group', ABSNavVerticalGroup);
registerComponent('vertical-collapse', ABSNavVerticalCollapse);
registerComponent('vertical-item', ABSNavVerticalItem);
registerComponent('vertical-link', ABSNavVerticalLink);
registerComponent('horizontal-group', ABSNavHorizontalGroup);
registerComponent('horizontal-collapse', ABSNavHorizontalCollapse);
registerComponent('horizontal-item', ABSNavHorizontalItem);
registerComponent('horizontal-link', ABSNavHorizontalLink);
registerComponent('vertical-divider', () => <Divider className="my-16" />);
registerComponent('horizontal-divider', () => <Divider className="my-16" />);

function ABSNavigation(props) {
  const options = _.pick(props, [
    'navigation',
    'layout',
    'active',
    'dense',
    'className',
    'onItemClick',
    'firstLevel',
    'selectedId',
    'disabled'
  ]);
  if (props.navigation.length > 0) {
    return (
      <>
        {inputGlobalStyles}
        {props.layout === 'horizontal' && <ABSNavHorizontalLayout1 {...options} />}
        {props.layout === 'vertical' && <ABSNavVerticalLayout1 {...options} />}
        {props.layout === 'vertical-2' && <ABSNavVerticalLayout2 {...options} />}
      </>
    );
  }
  return null;
}

ABSNavigation.propTypes = {
  navigation: PropTypes.array.isRequired,
};

ABSNavigation.defaultProps = {
  layout: 'vertical',
};

export default memo(ABSNavigation);
